module.exports = __webpack_public_path__ + "img/yuni_icons.f5424f36.svg";